// extracted by mini-css-extract-plugin
export var button = "confirmation-modal-module--button--ed846";
export var buttonClose = "confirmation-modal-module--button-close--3f68d";
export var buttons = "confirmation-modal-module--buttons--d4ffb";
export var closeButton = "confirmation-modal-module--close-button--246cc";
export var confirmation = "confirmation-modal-module--confirmation--49e4d";
export var contentBox = "confirmation-modal-module--content-box--51598";
export var emotics = "confirmation-modal-module--emotics--16e8a";
export var reverse = "confirmation-modal-module--reverse--74cf1";
export var titleText = "confirmation-modal-module--title-text--06d14";